import { isIsoDate } from './date_and_time'
import { isRelativeFilePath } from './file'
import { _dictionary } from './translate'
import React from 'react'
import { useAppSelector } from '../redux/hooks'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'
import { useHistory } from 'react-router-dom'

const locale = 'en-GB'

/**
 *
 * @param value
 * @param params { showBooleanOrNot: boolean }
 * @return {string|null}
 * @private
 */
export const _print_model_data = (value, params = {}) => {
  if (isIsoDate(value)) {
    console.log('update model data - isIsoDate')
    return new Date(value).toLocaleString(locale)
  }
  value = _updateRelativeFilePath(value)
  if (typeof value === 'object' && value !== null) {
    return ''
  }
  if (params?.showBooleanOrNot && typeof value === 'boolean') {
    return value.toString()
  }

  return value
}

export const _updateRelativeFilePath = (value) => {
  if (isRelativeFilePath(value)) {
    console.log('update model data - isRelativeFilePath')
    return process.env.REACT_APP_FILE_SYSTEM_URL + value.substring(1)
  } else {
    return value
  }
}

export const _default_value_regexp_decode = (value) => {
  if (value === 'true') return true
  else if (value === 'false') return false
  return value
}

export const _fetch_ids_from_model_data = (value, dataLabel) => {
  if (value && value.data && value.data.length > 0) {
    return value.data.map((option) => {
      return _fetch_id_from_single_model_data(option, dataLabel)
    })
  }
  return []
}

export const _fetch_id_from_single_model_data = (value, dataLabel) => {
  if (value === null || typeof value.attributes === 'undefined' || typeof value.id === 'undefined')
    return null

  return {
    label: getObjectValueByKey(value.attributes, dataLabel || 'code', ''),
    value: value.id,
  }
}

export const _construct_enum_option_from_single_model_data = (value, lang = null) => {
  if (typeof value !== 'string') return null

  const translate = _dictionary(lang)

  return {
    label: translate(value),
    value: value,
  }
}

export const getCollectibleAttributes = (collectible, key, fallbackValue) => {
  let searchTarget = key === 'id' ? collectible : collectible?.attributes || collectible
  const key_parts = key.split('.') // split key by dot (handle server components)
  key_parts.map((part) => {
    if (searchTarget) {
      const containSquareInPart = part.match(/\[(.*?)\]/)
      if (typeof searchTarget[part] !== 'undefined') {
        searchTarget = searchTarget[part]
      } else if (
        (containSquareInPart?.length || 0 === 2) &&
        typeof searchTarget[part.replaceAll(containSquareInPart[0], '')] !== 'undefined' &&
        searchTarget[part.replaceAll(containSquareInPart[0], '')] !== null &&
        typeof searchTarget[part.replaceAll(containSquareInPart[0], '')][containSquareInPart[1]] !==
          'undefined'
      ) {
        searchTarget =
          searchTarget[part.replaceAll(containSquareInPart[0], '')][containSquareInPart[1]]
      } else {
        searchTarget = fallbackValue
      }
    }
  }) // then fetch value by key

  return searchTarget
}

export const getObjectValueByKey = (object, dataLabel, fallbackValue) => {
  let response = ''

  const squareBracketValues = dataLabel.match(/(\[.+?\])/g) // array | null
  if (squareBracketValues) {
    response = dataLabel
    squareBracketValues.map((bracketValue) => {
      let bracketInnerValue = bracketValue.replaceAll('[', '').replaceAll(']', '')
      response = response.replaceAll(bracketValue, object[bracketInnerValue] || fallbackValue)
    })
  } else {
    response = object[dataLabel] || fallbackValue
  }

  if (typeof response === 'number') response = response.toString()
  return response
}

export const loadIntegerValueToOptionFromOptions = (value, options) => {
  if (options.length > 0 && typeof value === 'number') {
    return options.find((option) => option.value === value)
  }
  return value
}

/**
 * An recursive version of { ...object1, ...object2 }
 * @param object1 mixed
 * @param object2 mixed
 * @return {*}
 */
export const spread_combine_objects_recursively = (object1, object2) => {
  if (object1 === null && object2 === null) return null
  else if (object1 === null) return object2
  else if (object2 === null) return object1

  for (const property in object2) {
    if (typeof object1[property] === 'object' && typeof object2[property] === 'object')
      object1[property] = spread_combine_objects_recursively(object1[property], object2[property])
    else object1[property] = object2[property]
  }

  for (const property in object1) {
    object1[property] = extract_data_id_from_object(object1[property])
  }
  return object1
}

export const extract_data_id_from_object = (object) => {
  if (typeof object !== 'object') return object
  // else if (object['data'] !== null)

  if (object !== null && typeof object['data'] !== 'undefined') {
    if (object['data'] === null) {
      object = null
    } else if (Array.isArray(object['data'])) {
      object = object['data'].map((data) => data['id'] || null)
    } else if (typeof object['data']['id'] !== 'undefined') {
      object = object['data']['id']
    }
  } else {
    for (const property in object) {
      if (object[property] !== null && typeof object[property] === 'object') {
        object[property] = extract_data_id_from_object(object[property])
      }
    }
  }
  return object
}

export const simplifyModelAttributesUsingId = (object) => {
  Object.entries(object).map(([key, value], index) => {
    if (value?.data && typeof value.data === 'object' && value.data.length > 0) {
      let updatedValue = value.data.map((singleData) =>
        singleData.id && singleData.attributes ? singleData.id : singleData,
      )
      object[key] = updatedValue
    }
  })
  delete object.id
  return object
}

/**
 *
 * @param formElements
 * @return formAttributes[]
 */
export const extractFormAttributes = (formElements) => {
  const newFormAttributes = []
  formElements.map((formElement) => {
    if (formElement.isLayout) {
      newFormAttributes.push(...extractFormAttributes(formElement.children))
    } else {
      newFormAttributes.push(formElement)
    }
  })
  return newFormAttributes
}

export const convertWhatsappObjectToString = (whatsappObject) => {
  let whatsappString = ''
  if (whatsappObject) {
    if (whatsappObject.country_code) whatsappString = whatsappString + whatsappObject.country_code
    if (whatsappObject.area_code) whatsappString = whatsappString + whatsappObject.area_code
    if (whatsappObject.contact_number)
      whatsappString = whatsappString + whatsappObject.contact_number
  }
  return whatsappString
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const constructDefaultChanges = (formAttributes) => {
  let changes = {}
  formAttributes.map((formAttribute) => {
    if (formAttribute.isLayout && formAttribute.layoutPattern) {
      changes = { ...changes, ...constructDefaultChanges(formAttribute.children) }
      return
    }

    if (formAttribute.defaultValue) {
      // 'single-select' could update the default value after its internal API call
      if (formAttribute.tag !== 'single-select' && formAttribute.tag !== 'multi-select') {
        changes[formAttribute.value] = formAttribute.defaultValue
      }
    } else {
      // FORCE setting default value even no 'defaultValue' passed in from formAttribute
      if (formAttribute.tag === 'switch') {
        changes[formAttribute.value] = false
      }
    }
  })

  // console.log('[constructDefaultChanges]: ', changes)
  return changes
}

export const bindPlaceholder = (placeholder_string) => {
  if (!placeholder_string) return ''

  if (placeholder_string.includes('[minimum_display_template_row_number]')) {
    placeholder_string = placeholder_string.replace(
      /\[minimum_display_template_row_number\]/g,
      typeof window !== 'undefined'
        ? JSON.parse(localStorage.getItem('globalConfiguration') || '{}')
            ?.minimum_display_template_row_number || '0'
        : '0',
    )
  }

  return placeholder_string
}

export const usePermission = (
  permission,
  pageType,
  redirectTo404ForForbiddenAccess = true,
  options = {
    accessPageKey: '',
    createCollectibleKey: 'create',
    updateCollectibleKey: 'update',
    deleteCollectibleKey: 'delete',
    haveDownloadDocumentFeature: false,
    haveVersioningFeature: false,
  },
) => {
  const currentUser = useAppSelector(selectCurrentUser)
  const history = useHistory()
  const [disableAccess, setDisableAccess] = React.useState(true)
  const [disableCreate, setDisableCreate] = React.useState(true)
  const [disableUpdate, setDisableUpdate] = React.useState(true)
  const [disableDelete, setDisableDelete] = React.useState(true)
  const [disableDownloadDocument, setDisableDownloadDocument] = React.useState(true)
  const [disableViewVersionsList, setDisableViewVersionsList] = React.useState(true)
  const {
    createCollectibleKey = 'create',
    updateCollectibleKey = 'update',
    deleteCollectibleKey = 'delete',
    haveDownloadDocumentFeature = false,
    haveVersioningFeature = false,
  } = options
  let accessPageKey
  if (options.accessPageKey) {
    accessPageKey = options.accessPageKey
  } else {
    switch (pageType) {
      case 'detail':
        accessPageKey = 'findOne'
        break
      case 'create':
        accessPageKey = 'create'
        break
      case 'listing':
        accessPageKey = 'find'
        break
      default:
        accessPageKey = ''
    }
  }
  React.useEffect(() => {
    const permissions = currentUser?.permissions?.[permission]
    if (
      (!permissions || !permissions?.includes(accessPageKey)) &&
      redirectTo404ForForbiddenAccess
    ) {
      history.push('/404')
    }
    if (permissions) {
      setDisableAccess(!permissions.includes(accessPageKey))
      setDisableCreate(!permissions.includes(createCollectibleKey))
      setDisableUpdate(!permissions.includes(updateCollectibleKey))
      setDisableDelete(!permissions.includes(deleteCollectibleKey))
      if (haveDownloadDocumentFeature) setDisableDownloadDocument(!permissions.includes('download'))
      if (haveVersioningFeature) setDisableViewVersionsList(!permissions.includes('versions'))
    }
  }, [currentUser])

  let permissionsFlag = { disableAccess, disableCreate, disableUpdate, disableDelete }
  if (haveDownloadDocumentFeature) permissionsFlag = { ...permissionsFlag, disableDownloadDocument }
  if (haveVersioningFeature) permissionsFlag = { ...permissionsFlag, disableViewVersionsList }

  return permissionsFlag
}

export const validateEmailsFields = (fieldValue, key) => {
  let emailIsValid = true

  const emailRegex =
    /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,})[\W]*$/
  if (fieldValue.trim() !== '' && !emailRegex.test(fieldValue)) {
    emailIsValid = false
  }

  return { emailIsValid }
}

export const updateCreationDataWithDataBinding = (
  creationData,
  pageParams,
  activeBusinessEntity = null,
) => {
  for (const key in creationData) {
    // bind ':page_id'
    if (typeof creationData[key] === 'string')
      creationData[key] = creationData[key]
        .replace(':page_id', pageParams.id)
        .replace(':active_business_entity', activeBusinessEntity?.id || null)
  }

  return creationData
}

export const dataObjectPackerForAPICall = (data, endPoint) => {
  if (endPoint.startsWith('/users/') || endPoint.startsWith('/users-permissions/')) return data

  return {
    data: data, // update collectible field(s)
  }
}

export const convertDottedKeyToObjectStructure = (changed_text_fields, collectible_attributes) => {
  const dottedKeys = Object.keys(changed_text_fields).filter((key) => key.includes('.')) // get keys of all dotted text fields
  dottedKeys.map((key) => {
    const reversed_key_parts = key.split('.').reverse() // split key by dot (handle server components)
    let _targetObject = {}
    reversed_key_parts.map((part, index) => {
      if (index === 0) {
        _targetObject[part] = changed_text_fields[key]
      } else if (
        reversed_key_parts.length - 1 === index &&
        typeof collectible_attributes[part] !== 'undefined'
      ) {
        // Special handling: Merge changed field(s) into current collectible value (for SERVER COMPONENT data only) to fulfill submission need
        // console.log('final compare: ', collectible_attributes[part], _targetObject)
        _targetObject = {
          [part]: spread_combine_objects_recursively(collectible_attributes[part], _targetObject),
        }
      } else {
        _targetObject = { [part]: _targetObject }
      }
    }) // then fetch value by key
    changed_text_fields = spread_combine_objects_recursively(changed_text_fields, _targetObject)
    delete changed_text_fields[key]
  })
  return changed_text_fields
}

const conditionValuePostProcess = (conditionValue) => {
  switch (conditionValue) {
    case 'null':
      return null
    default:
      return conditionValue
  }
}

export const checkCondition = (conditionStatement, collectible) => {
  if (conditionStatement.includes('=')) {
    const [conditionKey, conditionValue] = conditionStatement.split('=')
    return (
      getCollectibleAttributes(collectible, conditionKey, '') ==
      conditionValuePostProcess(conditionValue)
    )
  } else if (conditionStatement.includes('<>')) {
    const [conditionKey, conditionValue] = conditionStatement.split('<>')
    return (
      getCollectibleAttributes(collectible, conditionKey, '') !==
      conditionValuePostProcess(conditionValue)
    )
  }
}

export const generateRandomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16)
  return {
    main: '#' + randomColor,
  }
}
